import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=a09796fe&scoped=true&"
import script from "./Cookies.vue?vue&type=script&lang=ts&"
export * from "./Cookies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09796fe",
  null
  
)

export default component.exports